import api from '@/api/index.js'

const discount = {
  state: {
    loading: false,
    updating: false,
    data: [],
    error: null
  },

  mutations: {
    SET_DISCOUNTS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_DISCOUNTS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_DISCOUNTS: (state, discounts) => {
      state.data = discounts;
      state.loading = false;
    },
    SET_DISCOUNTS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
    SET_DISCOUNT_ACTIVATED: (state, activated) => {
      if (state.data) {
        state.data = state.data.filter(item => {
          if (item.id == activated.id) {
            item.active = activated.active;
            item.updated_at = activated.updated_at;
          }
          return item
        });
      }
      state.updating = false;
    },
    SET_DISCOUNT_DELETED: (state, deleted) => {
      if (state.data) {
        state.data = state.data.filter(item => item.id != deleted.id);
      }
      state.updating = false;
    },
    SET_DISCOUNT_UPDATED: (state, changed) => {
      if (state.data) {
        state.data = state.data.filter(item => {
          if (item.id == changed.id) {
            item.description = changed.description;
            item.sort_priority = changed.sort_priority;
            item.type = changed.type;
            item.updated_at = new Date();
          }
          return item
        });
      }
      state.updating = false;
    },
  },

  actions: {
    LoadDiscounts({commit}) {
      commit('SET_DISCOUNTS', [])
      commit('SET_DISCOUNTS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_DISCOUNTS_LOADING', true)
      return api.get('discounts?limit=300&offset=0').then(response => {
        commit('SET_DISCOUNTS', response)
      }).catch(error => {
        commit('SET_DISCOUNTS_ERROR', error)
        commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
      })
    },
    CreateDiscount({commit}, payload) {
      commit('SET_DISCOUNTS_UPDATING', true);
      commit('SET_DISCOUNTS_ERROR', null)
      commit('SET_ERROR', null)
      return api.post(`discounts`, payload)
        .then((response) => {
          commit('SET_DISCOUNTS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_DISCOUNTS_ERROR', error);
          commit('SET_DISCOUNTS_UPDATING', false);
        })
    },
    UpdateDiscount({commit}, payload) {
      commit('SET_DISCOUNTS_UPDATING', true);
      commit('SET_DISCOUNTS_ERROR', null)
      commit('SET_ERROR', null)
      return api.put(`discounts/${payload.id}`, payload)
        .then((response) => {
          commit('SET_DISCOUNT_UPDATED', payload);
        })
        .catch((error) => {
          commit('SET_DISCOUNTS_ERROR', error);
          commit('SET_DISCOUNTS_UPDATING', false);
        })
    },
    ActivateDiscount({commit}, id) {
      commit('SET_DISCOUNTS_UPDATING', true);
      commit('SET_DISCOUNTS_ERROR', null)
      commit('SET_ERROR', null)
      return api.patch(`discounts/${id}/activate`)
        .then((response) => {
          commit('SET_DISCOUNT_ACTIVATED', response);
        })
        .catch((error) => {
          commit('SET_DISCOUNTS_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_DISCOUNTS_UPDATING', false);
        })
    },
    DeleteDiscount({commit}, payload) {
      commit('SET_DISCOUNTS_UPDATING', true);
      commit('SET_DISCOUNTS_ERROR', null)
      commit('SET_ERROR', null)
      return api.delete(`discounts/${payload.id}`)
        .then((response) => {
          commit('SET_DISCOUNT_DELETED', payload);
        })
        .catch((error) => {
          commit('SET_DISCOUNTS_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_DISCOUNTS_UPDATING', false);
        })
    },
  }
}

export default discount
